export interface IUser {
    username: string,
    id: number,
    email: string,
    fullpath: string,
    user_profile: IProfile,
    profile?: IProfile,
    full_name?: string,
    account_activation_token?: string,
    countryName?: string,
    billingCountryName?: string,
    role?: string,
    image?: string
}

export interface IProfile {
    billing_city: string,
    billing_country_id: string,
    billing_first: string,
    billing_last: string,
    billing_middle: string,
    billing_passport: string,
    billing_phone: string,
    card?: string,
    birthday: string,
    city: string,
    country_id: number,
    first: string,
    id: number,
    image: string,
    last: string,
    passport: string,
    phone: string,
    user_id: number,
}

export interface IHolder {
    id: number,
    full_name: string,
    username: string,
    status: number,
    created_at: number,
    email?: string,
    profile: IProfile,
    composition_count: number,
    doxod?: string,
    views?: number,
    all_doxod?: string,
    balance?: string,
    waiting?: string,
    payed?: string,
    billingCountryName?: string,
    role?: string,
    payment_blocked?: number
}

export interface IProducer {
    id: number,
    full_name: string,
    username: string,
    status: number,
    created_at: number,
    profile: IProfile,
    composition_count: number,
    doxod?: string,
    views?: number,
    all_doxod?: string,
    balance?: string,
    payed?: string
}

export interface ICountry {
    name: string,
    id: number
}

export interface IObject {
    name: string,
    id: number,
    youtube_id: string,
    status: number,
    upload_id: number,
    created_at: string,
    place: string,
    holder: IHolder,
    rate: number,
    coholders: IHolder[],
    doxod: number,
    views: number
}

export interface IGroup {
    name: string,
    id: number,
    holders_count: number
}

export interface IBlacklist {
    name: string,
    id: number,
    youtube_id: string,
    created_at: string
}

export interface ITransaction {
    id: number,
    name: string,
    status: number,
    user_id: number,
    currency: number,
    request_date: string,
    payment_date: string,
    code: string,
    comment: string,
    statusName: string,
    type: number,
    upload_id: number,
    upload_payment_id: number,
    date: string,
    typeName: string,
    user?: IUser,
    place?: string,
    balance: number,
    uz_transactions_id?: number
}

export interface IUploads {
    id: number,
    filename: string,
    user: IUser,
    created_at: string,
    views_count: number,
    users_count: number,
    compositions_count: number
}

export interface IUploadPayments {
    id: number,
    filename: string,
    user: string,
    created_at: string,
    count: number,
}

export interface IPaymentSave {
    id: number,
    matrix: string,
    created_at: string,
    updated_at: string,
}

export interface IMusic {
    id: number,
    user: IUser,
    user_id: number,
    name: string,
    path: string,
    status: EMusicStatus,
    created_at: string,
    co: string,
}

export enum EMusicStatus {
    MODERATING = 1,
    ACCEPTED = 2,
    REJECTED = 3,
}

export interface IProducerUser {
    id: number,
    producer_id: number,
    user_id: number,
    created_at: string,
    type: number,
    typeName: string,
    producer: IUser,
    user: IUser
}

export interface IUserChange {
    id: number,
    username: string,
    first: string,
    last: string,
    passport: string,
    birthday: string,
    country_id: number,
    city: string,
    phone: string,
    email: string,
    image: string,
    created_at: string,
    countryName: string,
    user_id: number,
    user: IUser,
    billing_city: string,
    billing_country_id: string,
    billingCountryName: string,
    billing_first: string,
    billing_last: string,
    billing_middle: string,
    billing_passport: string,
    billing_phone: string,
}

export interface ITicketHead {
    id: number,
    user_id: number,
    department: string,
    topic: string,
    statusName: string,
    status: number,
    date_update: string,
    user: IUser
}

export interface ITicketBody {
    id_head: number,
    name_user: string,
    text: string,
    date: string,
    user: IUser,
    tickedHead: ITicketHead,
    client: number
}